// src/pages/calidad/PpniPncCaptura.jsx
// Captura de PPNI y PNC con el formato F-CAL-05 (Seguimiento a PPNI y PNC).
import { useEffect, useState } from 'react';
import api from '../../services/api';
import s from '../mantenimiento/estilos';
import PpniPncFormulario, { VACIO, faltantes, fueraDeLista } from './PpniPncFormulario';

const pad = (n) => String(n).padStart(2, '0');
const hoyISO = () => { const d = new Date(); return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; };
const nuevoFormulario = (anterior = {}) => ({
  ...VACIO,
  fecha_deteccion: hoyISO(),
  // Se conservan entre capturas los datos que suelen repetirse en un mismo turno
  turno: anterior.turno || '',
  area_proceso: anterior.area_proceso || '',
  quien_captura: anterior.quien_captura || '',
});

export default function PpniPncCaptura() {
  const [catalogos, setCatalogos] = useState(null);
  const [folio, setFolio] = useState('');
  const [form, setForm] = useState(nuevoFormulario());
  const [intento, setIntento] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState(null);
  const [error, setError] = useState(null);

  async function cargarFolio() {
    try {
      const r = await api.get('/api/calidad/ppni-pnc/siguiente-folio');
      setFolio(r.data.data.folio);
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    api.get('/api/calidad/ppni-pnc/catalogos')
      .then((r) => setCatalogos(r.data.data))
      .catch((err) => { console.error(err); setError('No se pudieron cargar las listas del formato.'); });
    cargarFolio();
  }, []);

  async function handleGuardar() {
    setIntento(true);
    const falta = faltantes(form);
    const malos = fueraDeLista(form, catalogos);
    if (falta.length || malos.length) {
      const partes = [];
      if (falta.length) partes.push(`Falta llenar: ${falta.join(', ')}.`);
      if (malos.length) partes.push(`Elige de la lista (o pide que se agregue al catálogo): ${malos.join('; ')}.`);
      setMensaje({ tipo: 'error', texto: partes.join(' ') });
      return;
    }
    try {
      setGuardando(true);
      setMensaje(null);
      const payload = { ...form };
      if (!payload.disposicion) delete payload.firma_disposicion;
      const res = await api.post('/api/calidad/ppni-pnc/registros', payload);
      setMensaje({
        tipo: 'ok',
        texto: `✓ Folio ${res.data.data.folio} capturado${form.disposicion ? ` con disposición: ${form.disposicion}` : ' — queda pendiente de disposición'}.`,
      });
      setForm(nuevoFormulario(form));
      setIntento(false);
      cargarFolio();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: err.response?.status === 403 ? 'No tienes permiso de captura en Calidad.' : err.response?.data?.error || 'No se pudo guardar el registro.' });
    } finally {
      setGuardando(false);
    }
  }

  if (error) return <div style={{ ...s.paginaContenedor, color: '#B23A48' }}>{error}</div>;
  if (!catalogos) return <div style={s.paginaContenedor}>Cargando...</div>;

  const colorMensaje = mensaje?.tipo === 'ok' ? '#3E7C5A' : '#B23A48';

  return (
    <div style={{ ...s.paginaContenedor, maxWidth: 900 }} className="contenedor-captura">
      <div style={{ ...s.headerFila, alignItems: 'flex-start', gap: 12, flexWrap: 'wrap', marginBottom: 12 }}>
        <div>
          <h1 style={{ ...s.tituloPagina, marginBottom: 2 }}>Captura de PPNI y PNC</h1>
          <div style={{ fontSize: 12, color: '#8A7690' }}>F-CAL-05 · Seguimiento a PPNI y PNC</div>
        </div>
        <div style={x.folio}>
          <div style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.5, color: '#6E4F80' }}>Número de folio</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#2A1830' }}>{folio || '—'}</div>
          <div style={{ fontSize: 10, color: '#8A7690' }}>se confirma al guardar</div>
        </div>
      </div>

      {mensaje && <div style={{ ...s.mensaje, color: colorMensaje }}>{mensaje.texto}</div>}

      <div style={s.tarjeta}>
        <PpniPncFormulario valores={form} onCambio={setForm} catalogos={catalogos} intento={intento} s={s} />

        {mensaje && <div style={{ ...s.mensaje, color: colorMensaje, marginTop: 16 }}>{mensaje.texto}</div>}
        <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
          <button onClick={handleGuardar} disabled={guardando} style={{ ...x.botonCapturar, opacity: guardando ? 0.7 : 1 }}>
            {guardando ? 'Guardando...' : 'Capturar'}
          </button>
          <button
            onClick={() => { if (window.confirm('¿Borrar lo capturado en el formulario?')) { setForm(nuevoFormulario(form)); setIntento(false); setMensaje(null); } }}
            style={x.botonBorrar}
          >
            Borrar
          </button>
        </div>
      </div>
    </div>
  );
}

const x = {
  folio: { background: '#F3E6F7', border: '1px solid #D9C2E3', borderRadius: 10, padding: '8px 16px', textAlign: 'center', minWidth: 130 },
  botonCapturar: { flex: 1, padding: '12px', fontSize: 14, fontWeight: 700, color: '#fff', background: '#6A2C75', border: 'none', borderRadius: 8, cursor: 'pointer' },
  botonBorrar: { padding: '12px 20px', fontSize: 13, fontWeight: 600, color: '#4F7CA8', background: '#EAF2FA', border: '1px solid #B7CDE3', borderRadius: 8, cursor: 'pointer' },
};